import { DataServer } from "../../../../config.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

interface ElementLiabraryState {
  ElementLiabrary: {
    load: boolean;
    data: [];
  };
}

export const ElementLiabrarySlice = createSlice({
  name: "ElementLiabrary",
  initialState: {
    ElementLiabrary: {
      load: false,
      data: [],
    },
  } as ElementLiabraryState,
  reducers: {
    resetElementLiabraryState: (state: any) => {
        state.ElementLiabrary.data = [];
    },
},
  extraReducers: (builder: any) => {
    builder
      .addCase(fetchElementLiabrary.pending, (state: ElementLiabraryState) => {
        state.ElementLiabrary.load = true;
      })
      .addCase(fetchElementLiabrary.fulfilled, (state: ElementLiabraryState, action: any) => {
        state.ElementLiabrary.data = action.payload;
        state.ElementLiabrary.load = false;
      })
      .addCase(fetchElementLiabrary.rejected, (state: ElementLiabraryState) => {
        state.ElementLiabrary.load = false;
      })
  },
});

export const { resetElementLiabraryState } = ElementLiabrarySlice.actions;
export default ElementLiabrarySlice.reducer;

export const fetchElementLiabrary = createAsyncThunk(
  "ElementLiabrary/fetchElementLiabrary",
  async (param: { apiParam : {warehouse_id: any, tpi_firm_id: any, route_identify: any, project_pin: any} }, thunkAPI) => {
    try {      
      const { data } = await DataServer.post("api/getElementLibrary", {
        warehouse_id: param.apiParam.warehouse_id,
        tpi_firm_id: param.apiParam.tpi_firm_id,
        route_identify: param.apiParam.route_identify,
        project_pin: param.apiParam.project_pin
      });

      return data.data;

    } catch (error) {
      return(error);
    }
  }
);
